import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { openModals } from "../redux/modal.slice";
import ModalsEnum from "../enums/modal.enum";
import Button from "../components/Button";
import {UploadCloud02} from "@untitledui/icons/UploadCloud02";
import QuizTestCard from "../components/QuizTestCard";
import UploadCard from "../components/UploadCard";
import { LockIcon } from "../assets/imageAssets";
import { Link } from "react-router-dom";

const Main = () => {
    const categories = useSelector((state) => state.category.data);
    const user = useSelector((state) => state.me.data);
    const subscriptionStatus = user?.user_premium_status?.status;
    const isWithoutFreeTrial = !user?.user_premium_status?.has_premium_access || 
        subscriptionStatus === 'paused';

    const dispatch = useDispatch();
    const openUploadAndGenerateModal = () => {
        dispatch(
            openModals({
              modalIds: [ModalsEnum.UPLOAD_AND_GENERATE_MODAL],
            })
        );
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (token) {
            params.delete("token");
            const newSearch = params.toString();
            const newUrl =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                (newSearch ? `?${newSearch}` : "");

            window.history.replaceState({}, document.title, newUrl);
        }
    }, []);

    return (
        <div className={`main${isWithoutFreeTrial ? ' main--restricted' : ''}`}>
            {isWithoutFreeTrial && (
                <div className="main-overlay">
                    <div className="main-overlay__content">
                        <img src={LockIcon} alt="Locked Features" className="mb-20" />
                        <h2>Unlock Your Full Study Potential</h2>
                        <p>View all your past solutions, access AI-powered summaries, flashcards, quizzes, and smart tools designed to boost your academic performance.</p>
                        <Link to="/payment" className="primary-button">Upgrade to Unlock</Link>
                    </div>
                </div>
            )}
            <div className="container">
                <div className="main-head flex flex-align-start flex-between mb-56">
                    <div className='main-title mr-16'>
                        <h1 className='mb-8'>Your Smart Study Hub</h1>
                        <p>Build quizzes from your captured questions or uploaded files – prep smarter every time.</p>
                    </div>
                    <Button
                        text="Upload & Generate"
                        type="outlined"
                        icon={<UploadCloud02 size={20} className='mr-8' color={isWithoutFreeTrial ? '#B0B0B0' : '#4D4D4D'} />}
                        onClick={openUploadAndGenerateModal}
                        disabled={isWithoutFreeTrial}
                    />
                </div>
                <div className="cards-4 flex flex-wrap">
                    <UploadCard onClick={openUploadAndGenerateModal} disabled={isWithoutFreeTrial} />
                    {categories?.map((category) => {
                        return (
                            <QuizTestCard
                                key={category?.id}
                                title={category?.title}
                                href={`/categories/${category?.id}`}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Main;